import { render, staticRenderFns } from "./IconFolderSmall.vue?vue&type=template&id=e754103a&"
import script from "./IconFolderSmall.vue?vue&type=script&lang=js&"
export * from "./IconFolderSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e754103a')) {
      api.createRecord('e754103a', component.options)
    } else {
      api.reload('e754103a', component.options)
    }
    module.hot.accept("./IconFolderSmall.vue?vue&type=template&id=e754103a&", function () {
      api.rerender('e754103a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFolderSmall.vue"
export default component.exports